import type { TNetworkError } from '@/services/errors';

import { BaseService } from '@/services/api';

import type { TCheckCountQuery } from './verification.types';

class VerificationService extends BaseService {
  protected readonly serviceName = 'verificationService';

  public countChecks({ isOpen, identityOutcome, completedSince }: TCheckCountQuery): Promise<number | TNetworkError> {
    let builder = this.db
      .from('verification_checks')
      .select('id', { count: 'exact', head: true });

    if (isOpen) {
      builder = builder.is('completed_at', null);
    }

    if (identityOutcome) {
      builder = builder.eq('identity_outcome', identityOutcome);
    }

    if (completedSince) {
      builder = builder.gte('completed_at', completedSince);
    }

    return this.runCount(builder, 'countChecks');
  }
}

const verificationService = new VerificationService();

export {
  verificationService,
};
